import(/* webpackMode: "eager" */ "/home/socialnewbs/socialnewbs.com/frontend/shared/node_modules/next/dist/client/link.js");
